import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = '';

const ShopSection = () => {
  const navigate = useNavigate();
  const [shopImages, setShopImages] = useState({
    eyeglasses_image: "https://static.prod-images.emergentagent.com/jobs/929915db-def1-4d81-a6ce-06dd0e5d42cf/images/95287b920833abfc4a0edc959ff8a9999aa0067af2c6023fd00580a2d1a599ec.png",
    sunglasses_image: "https://customer-assets.emergentagent.com/job_929915db-def1-4d81-a6ce-06dd0e5d42cf/artifacts/uwybmqqo_A-young-Womens-big-frame-Sunglasses-2019.jpg"
  });

  useEffect(() => {
    // Fetch shop images from database
    const fetchShopImages = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/site-settings/shop`);
        if (response.ok) {
          const data = await response.json();
          setShopImages(data);
        }
      } catch (error) {
        console.error('Error fetching shop images:', error);
      }
    };
    fetchShopImages();
  }, []);

  const handleViewCollection = (category) => {
    navigate(`/collection?category=${category}`);
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-0 bg-white">
      <div className="grid md:grid-cols-2">
        {/* Eyeglasses */}
        <div 
          onClick={() => handleViewCollection('eyeglasses')}
          className="group relative overflow-hidden cursor-pointer"
        >
          <div className="relative h-[400px] md:h-[500px]">
            <img 
              src={shopImages.eyeglasses_image}
              alt="Shop Eyeglasses"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
              <h3 
                className="text-3xl md:text-4xl lg:text-5xl mb-2"
                style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}
              >
                Shop <span className="text-red-500">Eyeglasses</span>
              </h3>
            </div>
          </div>
          {/* Bottom text bar */}
          <div className="bg-white py-4 text-center">
            <p 
              className="text-xl md:text-2xl text-gray-800"
              style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}
            >
              Shop eyeglasses collection
            </p>
          </div>
        </div>

        {/* Sunglasses */}
        <div 
          onClick={() => handleViewCollection('sunglasses')}
          className="group relative overflow-hidden cursor-pointer"
        >
          <div className="relative h-[400px] md:h-[500px]">
            <img 
              src={shopImages.sunglasses_image}
              alt="Shop Sunglasses"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
              <h3 
                className="text-3xl md:text-4xl lg:text-5xl mb-2"
                style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}
              >
                Shop <span className="text-red-500">Sunglasses</span>
              </h3>
            </div>
          </div>
          {/* Bottom text bar */}
          <div className="bg-white py-4 text-center">
            <p 
              className="text-xl md:text-2xl text-gray-800"
              style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}
            >
              Shop sunglasses collection
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopSection;
